/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface AdminDataWorkOpenAccessFundedDTO
 */
export interface AdminDataWorkOpenAccessFundedDTO  {
    /**
     * 
     * @type {number}
     * @memberof AdminDataWorkOpenAccessFundedDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkOpenAccessFundedDTO
     */
    affiliation?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkOpenAccessFundedDTO
     */
    type?: string;
}

/**
 * Check if a given object implements the AdminDataWorkOpenAccessFundedDTO interface.
 */
export function instanceOfAdminDataWorkOpenAccessFundedDTO(value: object): value is AdminDataWorkOpenAccessFundedDTO {
    return true;
}

export function AdminDataWorkOpenAccessFundedDTOFromJSON(json: any): AdminDataWorkOpenAccessFundedDTO {
    return AdminDataWorkOpenAccessFundedDTOFromJSONTyped(json, false);
}

export function AdminDataWorkOpenAccessFundedDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDataWorkOpenAccessFundedDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'affiliation': json['affiliation'] == null ? undefined : json['affiliation'],
                  'type': json['type'] == null ? undefined : json['type'],
    };
}

export function AdminDataWorkOpenAccessFundedDTOToJSON(json: any): AdminDataWorkOpenAccessFundedDTO {
    return AdminDataWorkOpenAccessFundedDTOToJSONTyped(json, false);
}

export function AdminDataWorkOpenAccessFundedDTOToJSONTyped(value?: AdminDataWorkOpenAccessFundedDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'affiliation': value['affiliation'],
        'type': value['type'],
    };
}


